import { z } from 'zod';

export enum ExploreEventsFileType {
  CSV = 'csv',
}

export const exploreEventsFileTypeSchema = z.enum(ExploreEventsFileType);
